import { jsx as _jsx } from "react/jsx-runtime";
import Image from "@shared/components/contents/image/Image";
import React from "react";
import PresentationBlock from "./PresentationBlock";
const PresentationBlockPreview = () => {
    return (_jsx(PresentationBlock, { image: _jsx(Image, { file: { url: "/exemple-image.jpg" }, disableLazy: true }), imagePosition: "left", title: "Titre", subtitle: "Soustitre", description: "Zone avec la description", footnote: "Note en bas du bloc", backgroundColor: "#F5F5F5" }));
};
export default PresentationBlockPreview;
